import en from './locale/en.json';
import ja from './locale/ja.json';
import ko from './locale/ko.json';
import zh_TW from './locale/zh_TW.json';

export default {
  en,
  ja,
  ko,
  zh_TW,
};
